export default __webpack_public_path__ + "static/media/Pat_placement-13.46c3634e.png";